import axios from "@/axios";

export default {
    list() {
        return axios.get('instructions');
    },
    category: {
        list() {
            return axios.get('instructions/categories');
        },
    }
}